import React from 'react';
import './index.scss';
import Container from '../components/container';
import FeaturedEvent from '../components/featuredEvent';
import RecentArticles from '../components/RecentArticles';
import PodcastSection from '../components/PodcastSection';
import Layout from '../components/Layout';
import worldImg from '../assets/world.jpg';
import { useLocation } from '@reach/router';

interface Props {}

const IndexPage: React.FC<Props> = () => {
  const { pathname } = useLocation();

  return (
    <div>
      <Layout coverImage={worldImg} pageTitle="Events | Blogs | Podcasts - Fourth Act" pathname={pathname}>
        <Container className="featuredEventContainerPadding">
          <FeaturedEvent />
        </Container>
        <Container className="recentArticlesContainerPadding lightBlueBG">
          <RecentArticles showFew indexPage title="Recent Articles" showMoreButton />
        </Container>
        <Container id="podcast" className="podcastContainerPadding mediumBlueBG">
          <PodcastSection />
        </Container>
      </Layout>
    </div>
  );
};

export default IndexPage;
